import clinicaImg from "@/assets/clinica-podologia-belem-para-interior.jpg";
import recepcaoImg from "@/assets/clinica-podologia-belem-recepcao.jpg";
import hidratacaoImg from "@/assets/hidratacao-pes-ressecados-belem-para.jpg";
import massagemImg from "@/assets/massagem-terapeutica-pes-belem-para.jpg";
import orteseImg from "@/assets/ortese-correcao-unhas-belem-para.jpg";
import rosaImg from "@/assets/podologa-belem-para-rosa-chagas.jpg";
import calosImg from "@/assets/remocao-calos-calosidades-belem-para.jpg";
import saudeImg from "@/assets/saude-dos-pes-belem-para.jpg";
import micoseImg from "@/assets/tratamento-micose-unhas-belem-para.jpg";
import diabeticoImg from "@/assets/tratamento-pe-diabetico-belem-para.jpg";
import heroImg from "@/assets/tratamento-pes-belem-para-hero.jpg";
import unhaEncravadaImg from "@/assets/tratamento-unha-encravada-belem-para.jpg";
import verrugaImg from "@/assets/verrugas-plantares-belem-para.jpg";

export interface BlogPost {
  slug: string;
  title: string;
  category: string;
  excerpt: string;
  readTime: string;
  image: string;
  alt: string;
  paragraphs: { h?: string; p: string }[];
}

export const POSTS: Record<string, BlogPost> = {
  "podomasso-clinica-podologia-referencia-belem-do-para": {
    slug: "podomasso-clinica-podologia-referencia-belem-do-para",
    title: "Podomasso: A Clínica de Podologia Referência em Belém do Pará",
    category: "Podologia em Belém",
    excerpt: "Conheça a história, os valores e os diferenciais que fazem da Podomasso a escolha preferida dos paraenses para cuidar dos pés.",
    readTime: "7 min de leitura",
    image: clinicaImg,
    alt: "Clínica de podologia referência em Belém do Pará — Podomasso",
    paragraphs: [
      { p: "Quando se trata da saúde dos pés, escolher uma clínica de podologia em Belém do Pará faz toda a diferença. A Podomasso, sob a responsabilidade técnica da podóloga Rosa Chagas (CR8M 00017), tornou-se referência por unir técnica avançada, atendimento humanizado e biossegurança hospitalar." },
      { h: "Por que a Podomasso é referência em Belém do Pará", p: "Mais de 10 anos cuidando de pacientes paraenses, com mais de 500 atendimentos realizados e 98% de avaliações positivas. A clínica oferece tratamento para unha encravada, calos, micoses, pés diabéticos, verrugas plantares, órtese ungueal, hidratação profunda e massagem terapêutica." },
      { h: "Diferenciais que fazem da Podomasso a escolha certa", p: "Equipamentos eletrônicos modernos, esterilização rigorosa, ambiente acolhedor e a presença atenta da podóloga Rosa Chagas em cada consulta. Tudo pensado para que você se sinta seguro, confortável e bem cuidado." },
      { h: "Para quem é indicado o tratamento podológico", p: "Para qualquer pessoa que queira cuidar da saúde dos pés — especialmente diabéticos, idosos, gestantes, atletas e quem sente dor, desconforto ou tem unhas e pele em condições ruins. O tratamento podológico é prevenção, alívio e qualidade de vida." },
      { h: "Como agendar sua avaliação", p: "Você pode agendar sua consulta pelo WhatsApp (91) 8022-5829 ou pelo formulário de agendamento aqui no site." }
    ]
  },
  "tratamento-unha-encravada-belem-para": {
    slug: "tratamento-unha-encravada-belem-para",
    title: "Tratamento de Unha Encravada em Belém: Alívio Imediato e Seguro",
    category: "Tratamentos",
    excerpt: "Sofrendo com unha encravada? Descubra como o tratamento especializado em Belém pode resolver sua dor sem traumas e com rápida recuperação.",
    readTime: "6 min de leitura",
    image: unhaEncravadaImg,
    alt: "Tratamento de unha encravada na Podomasso em Belém",
    paragraphs: [
      { p: "A onicocriptose, popularmente conhecida como unha encravada, é uma das causas mais comuns de dor nos pés. Em Belém, a Podomasso oferece técnicas indolores para resolver esse problema definitivamente." },
      { h: "Causas comuns da unha encravada", p: "Corte incorreto das unhas, calçados apertados e fatores hereditários são os principais vilões. Tentar resolver em casa com alicates não esterilizados pode causar infecções graves." },
      { h: "O método Podomasso", p: "Utilizamos instrumentos de precisão e técnicas que priorizam o conforto do paciente. Em muitos casos, a aplicação de órteses pode corrigir a curvatura da unha, evitando que ela volte a encravar." }
    ]
  },
  "cuidados-pe-diabetico-belem": {
    slug: "cuidados-pe-diabetico-belem",
    title: "Cuidados com o Pé Diabético: Guia Completo para Pacientes em Belém",
    category: "Saúde Preventiva",
    excerpt: "O pé diabético exige atenção redobrada. Conheça as principais recomendações para evitar complicações e manter a saúde dos seus pés em dia.",
    readTime: "8 min de leitura",
    image: diabeticoImg,
    alt: "Avaliação de pé diabético na clínica em Belém",
    paragraphs: [
      { p: "Para quem convive com o diabetes, o cuidado com os pés não é apenas estética, é uma necessidade vital. Pequenas lesões podem evoluir rapidamente se não forem tratadas por um profissional de podologia qualificado." },
      { h: "A importância da inspeção diária", p: "Pacientes diabéticos em Belém devem verificar seus pés todos os dias em busca de cortes, bolhas ou vermelhidão. Como a sensibilidade pode estar reduzida, o espelho é um grande aliado." },
      { h: "Podologia especializada para diabéticos", p: "Na Podomasso, realizamos o corte técnico das unhas e a remoção de calosidades com extrema cautela, utilizando materiais 100% esterilizados para garantir total segurança." }
    ]
  },
  "como-eliminar-micose-de-unha-tratamento-eficaz": {
    slug: "como-eliminar-micose-de-unha-tratamento-eficaz",
    title: "Como Eliminar Micose de Unha: Tratamentos Eficazes em Belém do Pará",
    category: "Tratamentos",
    excerpt: "Cansado de tentar remédios caseiros para micose de unha? Conheça os tratamentos profissionais que realmente funcionam e recupere a beleza das suas unhas.",
    readTime: "7 min de leitura",
    image: micoseImg,
    alt: "Tratamento de onicomicose (micose de unha) em Belém",
    paragraphs: [
      { p: "A micose de unha (onicomicose) é uma infecção persistente que afeta a autoestima e a saúde. O clima úmido de Belém favorece a proliferação de fungos, tornando o tratamento profissional indispensável." },
      { h: "Por que tratamentos caseiros falham?", p: "Geralmente, as soluções caseiras não penetram na lâmina ungueal onde o fungo está instalado. É necessário um desbastamento técnico e o uso de princípios ativos específicos." },
      { h: "Acompanhamento podológico", p: "O tratamento de micose exige paciência. O acompanhamento mensal na Podomasso garante que a unha cresça saudável e livre de fungos." }
    ]
  },
  "remocao-de-calos-e-calosidades-belem": {
    slug: "remocao-de-calos-e-calosidades-belem",
    title: "Remoção de Calos e Calosidades: Conforto e Estética para seus Pés",
    category: "Cuidados Diários",
    excerpt: "Calosidades causam dor e desconforto ao caminhar. Saiba como a remoção profissional em Belém pode devolver a maciez e o bem-estar aos seus pés.",
    readTime: "5 min de leitura",
    image: calosImg,
    alt: "Remoção técnica de calosidades em clínica de podologia",
    paragraphs: [
      { p: "Os calos são defesas naturais da pele contra o atrito e a pressão. No entanto, quando excessivos, tornam-se dolorosos. A remoção incorreta pode causar ferimentos e infecções." },
      { h: "O perigo de 'cortar' calos em casa", p: "Muitas pessoas tentam remover calos com lâminas em casa, o que é extremamente perigoso. O podólogo utiliza técnicas de desbastamento seguro e identifica a causa da pressão excessiva." },
      { h: "Hidratação após a remoção", p: "Após remover as calosidades, a hidratação profunda é essencial para manter a elasticidade da pele e retardar o reaparecimento do problema." }
    ]
  },
  "ortese-ungueal-correcao-de-unhas-encravadas": {
    slug: "ortese-ungueal-correcao-de-unhas-encravadas",
    title: "Órtese Ungueal: O Aparelho que Corrige a Curvatura das Unhas",
    category: "Tecnologia",
    excerpt: "Suas unhas são muito curvas? A órtese ungueal é uma solução indolor e eficaz para corrigir o formato das unhas e evitar que encravem.",
    readTime: "6 min de leitura",
    image: orteseImg,
    alt: "Aplicação de órtese ungueal para correção de unhas",
    paragraphs: [
      { p: "Muitas pessoas sofrem com unhas 'em funil' ou excessivamente curvas. A órtese ungueal atua como um aparelho corretivo, exercendo uma tração suave para abrir a curvatura da unha." },
      { h: "Vantagens da órtese", p: "É um procedimento indolor, não invasivo e permite que o paciente mantenha suas atividades normais. É a melhor forma de prevenir unhas encravadas recorrentes." },
      { h: "Indicação profissional", p: "Na Podomasso em Belém, avaliamos o tipo ideal de órtese (fibra de memória molecular ou metálica) para cada caso específico." }
    ]
  },
  "verruga-plantar-olho-de-peixe-tratamento-belem": {
    slug: "verruga-plantar-olho-de-peixe-tratamento-belem",
    title: "Verruga Plantar (Olho de Peixe): Como Tratar sem Dor em Belém",
    category: "Tratamentos",
    excerpt: "A verruga plantar pode ser muito dolorosa ao caminhar. Conheça as opções de tratamento na Podomasso para eliminar o vírus e a lesão de forma segura.",
    readTime: "7 min de leitura",
    image: verrugaImg,
    alt: "Tratamento de verruga plantar em Belém do Pará",
    paragraphs: [
      { p: "Causada pelo vírus HPV, a verruga plantar é contagiosa e muitas vezes confundida com um calo comum. O tratamento deve ser feito com cuidado para não espalhar a lesão." },
      { h: "Diagnóstico correto", p: "O podólogo identifica a verruga pelos pontos enegrecidos e pela interrupção das linhas da pele. O tratamento profissional foca na eliminação da lesão e no fortalecimento da imunidade local." },
      { h: "Prevenção", p: "Evitar andar descalço em áreas públicas e não compartilhar calçados são medidas básicas de prevenção contra o vírus." }
    ]
  },
  "hidratacao-profunda-para-pes-ressecados": {
    slug: "hidratacao-profunda-para-pes-ressecados",
    title: "Hidratação Profunda: O Segredo para Pés Macios e sem Rachaduras",
    category: "Estética e Saúde",
    excerpt: "Pés ressecados e com fissuras são porta de entrada para bactérias. Descubra os benefícios da hidratação podológica profissional.",
    readTime: "5 min de leitura",
    image: hidratacaoImg,
    alt: "Procedimento de hidratação profunda nos pés",
    paragraphs: [
      { p: "O clima de Belém e o uso frequente de sandálias podem ressecar a pele dos pés, levando ao aparecimento de fissuras (rachaduras) que causam dor e sangramento." },
      { h: "Diferença entre hidratante comum e profissional", p: "A hidratação na clínica utiliza produtos com alta concentração de ureia e óleos essenciais, potencializados por técnicas de oclusão que garantem absorção profunda." },
      { h: "Prevenção de fissuras", p: "Manter os pés hidratados é a melhor forma de evitar fissuras. Recomendamos sessões mensais para manter a saúde e a estética dos pés impecáveis." }
    ]
  },
  "massagem-terapeutica-para-os-pes-beneficios": {
    slug: "massagem-terapeutica-para-os-pes-beneficios",
    title: "Massagem Terapêutica para os Pés: Relaxamento e Saúde em Belém",
    category: "Bem-estar",
    excerpt: "Muito além do relaxamento, a massagem nos pés melhora a circulação e alivia tensões do dia a dia. Conheça os benefícios para sua saúde.",
    readTime: "5 min de leitura",
    image: massagemImg,
    alt: "Sessão de massagem terapêutica nos pés na Podomasso",
    paragraphs: [
      { p: "Nossos pés suportam todo o peso do corpo e raramente recebem o descanso merecido. A massagem terapêutica podológica ajuda a drenar líquidos e relaxar a musculatura." },
      { h: "Melhora na circulação", p: "Para quem passa muito tempo em pé ou sentado, a massagem é fundamental para estimular o retorno venoso e diminuir o inchaço nos tornozelos." },
      { h: "Reflexologia e bem-estar", p: "A estimulação de pontos específicos nos pés pode trazer benefícios para todo o corpo, promovendo uma sensação de relaxamento profundo e redução do estresse." }
    ]
  },
  "podologia-para-idosos-importancia-do-cuidado": {
    slug: "podologia-para-idosos-importancia-do-cuidado",
    title: "Podologia para Idosos: Segurança e Qualidade de Vida na Terceira Idade",
    category: "Saúde Preventiva",
    excerpt: "Com o envelhecimento, os pés sofrem alterações que exigem cuidados especializados. Saiba por que a podologia é essencial para os idosos.",
    readTime: "7 min de leitura",
    image: saudeImg,
    alt: "Atendimento de podologia para pacientes idosos em Belém",
    paragraphs: [
      { p: "Na terceira idade, as unhas tendem a engrossar e a pele fica mais sensível. A dificuldade de alcançar os pés torna o corte das unhas um desafio perigoso para o idoso." },
      { h: "Prevenção de quedas", p: "Pés saudáveis e sem dor garantem um caminhar mais seguro, reduzindo o risco de quedas, que são uma grande preocupação para a saúde do idoso." },
      { h: "Atendimento humanizado", p: "Na Podomasso, oferecemos um atendimento paciente e cuidadoso, garantindo que o idoso se sinta confortável e receba o tratamento adequado para sua condição." }
    ]
  },
  "podologia-infantil-cuidados-desde-os-primeiros-passos": {
    slug: "podologia-infantil-cuidados-desde-os-primeiros-passos",
    title: "Podologia Infantil: Cuidados com os Pés desde os Primeiros Passos",
    category: "Saúde Infantil",
    excerpt: "Muitos problemas nos pés começam na infância. Saiba como identificar e tratar alterações nos pés das crianças em Belém.",
    readTime: "6 min de leitura",
    image: heroImg,
    alt: "Avaliação de podologia em crianças na Podomasso",
    paragraphs: [
      { p: "Os pés das crianças estão em constante desenvolvimento. Identificar precocemente problemas como unhas encravadas ou verrugas plantares evita complicações no futuro." },
      { h: "Atenção aos calçados", p: "O uso de calçados inadequados na infância pode deformar os pés. O podólogo pode orientar sobre a escolha correta e realizar cortes técnicos preventivos." },
      { h: "Tratamento lúdico", p: "Cuidar de crianças exige uma abordagem diferenciada para que elas não tenham medo do tratamento. Na Podomasso, criamos um ambiente acolhedor para os pequenos." }
    ]
  },
  "podologia-para-atletas-melhore-seu-desempenho": {
    slug: "podologia-para-atletas-melhore-seu-desempenho",
    title: "Podologia para Atletas: Melhore seu Desempenho e Evite Lesões",
    category: "Esportes",
    excerpt: "Atletas de Belém sofrem com o impacto constante nos pés. Descubra como a podologia esportiva pode ajudar a prevenir lesões e melhorar seus resultados.",
    readTime: "7 min de leitura",
    image: recepcaoImg,
    alt: "Cuidados podológicos para atletas e esportistas",
    paragraphs: [
      { p: "Corredores, jogadores de futebol e praticantes de crossfit submetem os pés a pressões extremas. Unhas pretas, calos e bolhas são problemas frequentes nesse público." },
      { h: "Prevenção de onicólise", p: "O trauma constante pode causar o descolamento da unha. O podólogo esportivo realiza o manejo adequado para evitar a perda da lâmina ungueal e infecções secundárias." },
      { h: "Análise da pisada", p: "Entender como você pisa e como isso afeta seus pés é o primeiro passo para escolher o calçado ideal e evitar dores crônicas." }
    ]
  },
  "fissuras-no-calcanhar-causas-e-tratamentos": {
    slug: "fissuras-no-calcanhar-causas-e-tratamentos",
    title: "Fissuras no Calcanhar: Por que Aparecem e como Tratar Definitivamente",
    category: "Tratamentos",
    excerpt: "Rachaduras nos calcanhares não são apenas um problema estético. Saiba por que elas surgem e como o tratamento podológico em Belém resolve a dor.",
    readTime: "6 min de leitura",
    image: hidratacaoImg,
    alt: "Tratamento de fissuras e rachaduras nos calcanhares",
    paragraphs: [
      { p: "As fissuras calcâneas ocorrem quando a pele está excessivamente seca e perde sua elasticidade natural, 'quebrando' sob o peso do corpo." },
      { h: "Fatores agravantes", p: "Excesso de peso, andar descalço, usar chinelos abertos e doenças como hipotireoidismo podem agravar o quadro de ressecamento." },
      { h: "Tratamento na clínica", p: "O desbastamento profissional das bordas da fissura permite que ela feche mais rápido, eliminando a dor e prevenindo a entrada de fungos e bactérias." }
    ]
  },
  "importancia-da-esterilizacao-na-podologia": {
    slug: "importancia-da-esterilizacao-na-podologia",
    title: "Biossegurança: A Importância da Esterilização na Podologia",
    category: "Segurança",
    excerpt: "Sua saúde em primeiro lugar. Saiba como a Podomasso garante a máxima segurança através de processos rigorosos de esterilização em Belém.",
    readTime: "5 min de leitura",
    image: clinicaImg,
    alt: "Processo de esterilização em autoclave na Podomasso",
    paragraphs: [
      { p: "A podologia lida com instrumentos perfurocortantes. Por isso, a esterilização correta é o pilar mais importante de qualquer clínica séria em Belém." },
      { h: "Uso da Autoclave", p: "Diferente de estufas antigas, a autoclave utiliza vapor sob pressão para eliminar 100% de vírus, fungos e bactérias, incluindo os vírus da Hepatite e HIV." },
      { h: "Materiais descartáveis", p: "Lixas, luvas e máscaras devem ser sempre descartáveis. Na Podomasso, cada kit de instrumentos é aberto na frente do paciente, garantindo total transparência e segurança." }
    ]
  },
  "como-cortar-as-unhas-dos-pes-corretamente": {
    slug: "como-cortar-as-unhas-dos-pes-corretamente",
    title: "Como Cortar as Unhas dos Pés Corretamente: Evite a Unha Encravada",
    category: "Dicas Práticas",
    excerpt: "Você sabia que a forma como você corta suas unhas pode causar sérios problemas? Aprenda as dicas de ouro dos podólogos para um corte seguro.",
    readTime: "5 min de leitura",
    image: unhaEncravadaImg,
    alt: "Exemplo de corte correto das unhas dos pés",
    paragraphs: [
      { p: "O erro mais comum é arredondar demais os cantos das unhas ou cortá-las muito curtas. Isso facilita para que a pele 'suba' e a unha encrave ao crescer." },
      { h: "O formato ideal", p: "As unhas dos pés devem ser cortadas em formato reto (quadrado), apenas suavizando as pontinhas com uma lixa para que não fiquem afiadas." },
      { h: "Instrumentos adequados", p: "Evite usar cortadores de unha de mão para os pés. Prefira alicates específicos de ponta reta, que oferecem mais precisão e segurança." }
    ]
  },
  "podologia-belem-preco-quanto-custa-uma-sessao": {
    slug: "podologia-belem-preco-quanto-custa-uma-sessao",
    title: "Podologia em Belém: Quanto Custa uma Sessão e por que Vale o Investimento",
    category: "Serviços",
    excerpt: "Entenda os valores da podologia em Belém do Pará e como o tratamento preventivo pode economizar tempo e dinheiro com sua saúde.",
    readTime: "6 min de leitura",
    image: recepcaoImg,
    alt: "Recepção da clínica de podologia em Belém",
    paragraphs: [
      { p: "Muitas pessoas deixam de ir ao podólogo por achar que é um serviço de luxo, mas a podologia é um investimento em saúde e mobilidade." },
      { h: "O custo do descaso", p: "Ignorar uma unha encravada ou uma ferida no pé diabético pode resultar em gastos muito maiores com medicamentos, cirurgias ou até hospitalização no futuro." },
      { h: "Transparência nos valores", p: "Na Podomasso, trabalhamos com preços justos que refletem a qualidade dos materiais, a expertise da podóloga Rosa Chagas e a segurança do ambiente hospitalar." }
    ]
  },
  "suor-excessivo-nos-pes-bromidrose-como-tratar": {
    slug: "suor-excessivo-nos-pes-bromidrose-como-tratar",
    title: "Suor Excessivo nos Pés (Bromidrose): Dicas de Podologia para o Clima de Belém",
    category: "Dicas Práticas",
    excerpt: "O calor de Belém favorece o suor excessivo e o mau cheiro nos pés. Conheça as estratégias para manter seus pés secos e saudáveis.",
    readTime: "6 min de leitura",
    image: saudeImg,
    alt: "Dicas para combater o suor excessivo nos pés",
    paragraphs: [
      { p: "A bromidrose plantar não é apenas falta de higiene, mas a ação de bactérias no suor acumulado. Em Belém, o calor intenso exige cuidados específicos." },
      { h: "Troca de calçados", p: "Nunca use o mesmo calçado dois dias seguidos. Deixe-os arejar em local ventilado para que a umidade evapore completamente." },
      { h: "Produtos indicados", p: "O uso de talcos antissépticos e sabonetes específicos, aliados ao corte técnico que evita o acúmulo de detritos sob a unha, ajuda muito no controle do odor." }
    ]
  },
  "beneficios-da-podologia-na-gravidez": {
    slug: "beneficios-da-podologia-na-gravidez",
    title: "Pés Inchados na Gravidez: Como a Podologia Pode Ajudar as Gestantes",
    category: "Saúde Feminina",
    excerpt: "A gestação traz grandes mudanças para o corpo da mulher, inclusive nos pés. Saiba como o podólogo pode garantir conforto nesse período.",
    readTime: "7 min de leitura",
    image: massagemImg,
    alt: "Cuidados podológicos para gestantes em Belém",
    paragraphs: [
      { p: "O aumento do peso e o inchaço (edema) nos membros inferiores são comuns na gravidez, tornando os pés mais sensíveis e propensos a unhas encravadas." },
      { h: "Dificuldade de alcance", p: "Com o crescimento da barriga, a gestante não consegue mais cuidar dos próprios pés. O podólogo assume esse papel com toda a segurança necessária." },
      { h: "Alívio imediato", p: "Sessões de hidratação e massagens leves ajudam a reduzir o desconforto e preparam os pés para o esforço final da gestação." }
    ]
  },
  "como-escolher-uma-boa-clinica-de-podologia-em-belem": {
    slug: "como-escolher-uma-boa-clinica-de-podologia-em-belem",
    title: "Como Escolher uma Boa Clínica de Podologia em Belém do Pará",
    category: "Dicas Práticas",
    excerpt: "Não entregue seus pés a qualquer pessoa. Saiba o que verificar antes de escolher seu podólogo em Belém.",
    readTime: "6 min de leitura",
    image: clinicaImg,
    alt: "Interior da Clínica Podomasso em Belém",
    paragraphs: [
      { p: "A escolha de um profissional de saúde é séria. Em Belém, existem muitos locais que oferecem serviços de pé e mão, mas a podologia clínica exige formação técnica." },
      { h: "Verifique o registro", p: "Um bom podólogo deve ter registro profissional e a clínica deve possuir alvará da vigilância sanitária. Isso garante que as normas de higiene sejam seguidas." },
      { h: "Avaliações de outros pacientes", p: "Busque por clínicas com boas referências no Google e redes sociais. O depoimento de quem já foi atendido é a melhor garantia de qualidade." }
    ]
  },
  "tendencias-da-podologia-moderna-em-2024": {
    slug: "tendencias-da-podologia-moderna-em-2024",
    title: "Tendências da Podologia Moderna: O que há de Novo para 2024",
    category: "Tecnologia",
    excerpt: "A tecnologia chegou aos cuidados com os pés. Conheça as inovações que estão tornando os tratamentos mais rápidos e eficazes.",
    readTime: "7 min de leitura",
    image: orteseImg,
    alt: "Inovações tecnológicas na podologia moderna",
    paragraphs: [
      { p: "A podologia evoluiu muito nos últimos anos. De novos materiais para órteses a técnicas de laserterapia, o foco é sempre o tratamento menos invasivo possível." },
      { h: "Laserterapia na podologia", p: "O uso do laser para tratar micoses e acelerar a cicatrização de feridas é uma realidade que traz resultados surpreendentes em menos tempo." },
      { h: "Materiais bio-compatíveis", p: "O uso de novos polímeros para órteses garante maior conforto e discrição para o paciente, sem perder a eficácia corretiva." }
    ]
  }
};
